/**
 * @fileoverview gRPC-Web generated client stub for legebill.site.membership.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: legebill/site/membership/v4/membership.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as legebill_site_membership_v4_membership_pb from '../../../../legebill/site/membership/v4/membership_pb';


export class MembershipServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetMembership = new grpcWeb.MethodDescriptor(
    '/legebill.site.membership.v4.MembershipService/GetMembership',
    grpcWeb.MethodType.UNARY,
    legebill_site_membership_v4_membership_pb.GetMembershipRequest,
    legebill_site_membership_v4_membership_pb.Membership,
    (request: legebill_site_membership_v4_membership_pb.GetMembershipRequest) => {
      return request.serializeBinary();
    },
    legebill_site_membership_v4_membership_pb.Membership.deserializeBinary
  );

  getMembership(
    request: legebill_site_membership_v4_membership_pb.GetMembershipRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_membership_v4_membership_pb.Membership>;

  getMembership(
    request: legebill_site_membership_v4_membership_pb.GetMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_membership_v4_membership_pb.Membership) => void): grpcWeb.ClientReadableStream<legebill_site_membership_v4_membership_pb.Membership>;

  getMembership(
    request: legebill_site_membership_v4_membership_pb.GetMembershipRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_membership_v4_membership_pb.Membership) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.membership.v4.MembershipService/GetMembership',
        request,
        metadata || {},
        this.methodDescriptorGetMembership,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.membership.v4.MembershipService/GetMembership',
    request,
    metadata || {},
    this.methodDescriptorGetMembership);
  }

  methodDescriptorListMemberships = new grpcWeb.MethodDescriptor(
    '/legebill.site.membership.v4.MembershipService/ListMemberships',
    grpcWeb.MethodType.UNARY,
    legebill_site_membership_v4_membership_pb.ListMembershipsRequest,
    legebill_site_membership_v4_membership_pb.ListMembershipsResponse,
    (request: legebill_site_membership_v4_membership_pb.ListMembershipsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_membership_v4_membership_pb.ListMembershipsResponse.deserializeBinary
  );

  listMemberships(
    request: legebill_site_membership_v4_membership_pb.ListMembershipsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_membership_v4_membership_pb.ListMembershipsResponse>;

  listMemberships(
    request: legebill_site_membership_v4_membership_pb.ListMembershipsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_membership_v4_membership_pb.ListMembershipsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_membership_v4_membership_pb.ListMembershipsResponse>;

  listMemberships(
    request: legebill_site_membership_v4_membership_pb.ListMembershipsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_membership_v4_membership_pb.ListMembershipsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.membership.v4.MembershipService/ListMemberships',
        request,
        metadata || {},
        this.methodDescriptorListMemberships,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.membership.v4.MembershipService/ListMemberships',
    request,
    metadata || {},
    this.methodDescriptorListMemberships);
  }

  methodDescriptorListSitePermissions = new grpcWeb.MethodDescriptor(
    '/legebill.site.membership.v4.MembershipService/ListSitePermissions',
    grpcWeb.MethodType.UNARY,
    legebill_site_membership_v4_membership_pb.ListSitePermissionsRequest,
    legebill_site_membership_v4_membership_pb.ListSitePermissionsResponse,
    (request: legebill_site_membership_v4_membership_pb.ListSitePermissionsRequest) => {
      return request.serializeBinary();
    },
    legebill_site_membership_v4_membership_pb.ListSitePermissionsResponse.deserializeBinary
  );

  listSitePermissions(
    request: legebill_site_membership_v4_membership_pb.ListSitePermissionsRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_membership_v4_membership_pb.ListSitePermissionsResponse>;

  listSitePermissions(
    request: legebill_site_membership_v4_membership_pb.ListSitePermissionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_membership_v4_membership_pb.ListSitePermissionsResponse) => void): grpcWeb.ClientReadableStream<legebill_site_membership_v4_membership_pb.ListSitePermissionsResponse>;

  listSitePermissions(
    request: legebill_site_membership_v4_membership_pb.ListSitePermissionsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_membership_v4_membership_pb.ListSitePermissionsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.membership.v4.MembershipService/ListSitePermissions',
        request,
        metadata || {},
        this.methodDescriptorListSitePermissions,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.membership.v4.MembershipService/ListSitePermissions',
    request,
    metadata || {},
    this.methodDescriptorListSitePermissions);
  }

}

